import React from "react";
import * as S from "./ContactSection.Style";
import Button from "../core/Button";

import { ReactComponent as IconCentral } from "../../../assets/images/habitacional/icon-central.svg";
import { ReactComponent as IconZapZap } from "../../../assets/images/habitacional/icon-whatsapp.svg";
import { ReactComponent as IconPhone } from "../../../assets/images/habitacional/icon-phone.svg";
import ContentSection from "../ContentSection";

const ContactSection = ({ isAssistance = true, noMargin = false }) => {
  const handleRedirectTo = () => {
    window.location.href = "/paravoce/habitacional/acionar_sinistro";
  };
  const ContactItem = ({
    icon,
    title,
    link,
    linkText,
    description,
    target,
  }) => {
    return (
      <S.Item>
        <S.ItemHeader>
          {icon}
          <div>
            <S.ItemDescription>{title}</S.ItemDescription>
            <S.ItemLink href={link} target={target}>
              {linkText}
            </S.ItemLink>
          </div>
        </S.ItemHeader>
        <S.ItemDescription>{description}</S.ItemDescription>
      </S.Item>
    );
  };
  const ContactItemZap = (
    <ContactItem
      icon={<IconZapZap />}
      title="Acionar pelo WhatsApp"
      link="https://wa.me/+5508007492020"
      linkText="0800 749 2020"
      description="Segunda a sexta, de 8h às 18h, exceto feriados."
      target="_blank"
    />
  );
  const ContactItemCentral = (
    <ContactItem
      icon={<IconCentral />}
      title="Acionar por telefone"
      link="tel:0800 274 1000"
      linkText="0800 274 1000"
      description="Das 8h às 19h, de segunda a sexta, exceto em feriados nacionais."
    />
  );
  return (
    <ContentSection themeColor noMargin={noMargin}>
      <S.Container>
        <S.Content>
          <S.Title>Quero acionar a cobertura (sinistro)</S.Title>
          <S.Paragraph>
            Em casos de falecimento, invalidez permanente ou danos ao seu lar
            causados por desastres naturais, incêndios ou outras situações,
            inicie seu pedido de indenização online, por WhatsApp ou telefone.
          </S.Paragraph>

          <Button variant="tertiary" onClick={() => handleRedirectTo()}>
            Iniciar pedido
          </Button>

          {isAssistance && (
            <S.PhoneNumber isAssistance={isAssistance}>
              {ContactItemZap}
              {ContactItemCentral}
            </S.PhoneNumber>
          )}
        </S.Content>
        {!isAssistance && (
          <S.PhoneNumber isAssistance={isAssistance}>
            {ContactItemZap}
            <S.HorizontalDivider />
            {ContactItemCentral}
          </S.PhoneNumber>
        )}
        {isAssistance && (
          <>
            <S.VerticalDivider />
            <S.Content>
              <S.Title>Quero acionar a assistência</S.Title>
              <S.Paragraph>
                Para serviços como chaveiro, eletricista e encanador, tanto para
                situações previstas quanto emergenciais no seu lar, acione a
                assistência pelo telefone.
              </S.Paragraph>

              <S.Item>
                <S.ItemHeader>
                  <IconPhone />
                  <S.ItemLinkCustom href="tel:0800 274 1000">
                    0800 274 1000
                  </S.ItemLinkCustom>
                </S.ItemHeader>
                <S.ItemDescription>
                  24h, todos os dias da semana.
                </S.ItemDescription>
              </S.Item>
            </S.Content>
          </>
        )}
      </S.Container>
    </ContentSection>
  );
};

export default ContactSection;
